import Text from '../../../Text'

import * as styles from './BirdviewCardPlaceholder.module.css'

function BirdviewCardPlaceholder({ children }) {
  return (
    <Text isSecondary Element='div' className={styles.placeholder}>
      {children}
    </Text>
  )
}

export default BirdviewCardPlaceholder
